export default function VendorCard({ vendor, onClick, isActive, onMouseEnter, onMouseLeave }) {
  const vendorInfo = vendor.vendors || {}

  const formatDistance = (miles) => {
    if (miles === null || miles === undefined) return null
    if (miles < 0.1) {
      return `${Math.round(miles * 5280)} ft`
    }
    return `${miles.toFixed(1)} mi`
  }

  // Group schedules by day
  const schedulesByDay = {}
  const dayOrder = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']

  for (const schedule of vendor.schedules || []) {
    const day = schedule.day_of_week
    if (!schedulesByDay[day]) {
      schedulesByDay[day] = []
    }
    schedulesByDay[day].push(schedule)
  }

  // Sort and format schedules
  const sortedDays = dayOrder.filter(day => schedulesByDay[day])

  return (
    <div
      className={`listing-card ${isActive ? 'active' : ''}`}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className="listing-card-content" style={{ padding: '16px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
          <div className="listing-card-title">{vendor.applicant}</div>
          {vendor.distance_miles !== null && (
            <span className="listing-card-distance">
              {formatDistance(vendor.distance_miles)}
            </span>
          )}
        </div>

        {vendorInfo.food_items && (
          <div className="listing-card-food" style={{ marginBottom: '12px' }}>
            {vendorInfo.food_items}
          </div>
        )}

        <div className="schedule-list">
          {sortedDays.slice(0, 3).map(day => (
            <div key={day} className="schedule-row">
              <span className="schedule-day">{day.slice(0, 3)}</span>
              <span className="schedule-times">
                {schedulesByDay[day].map((s, i) => (
                  <span key={i}>
                    {i > 0 && ', '}
                    {s.start_24}-{s.end_24}
                  </span>
                ))}
              </span>
            </div>
          ))}
          {sortedDays.length > 3 && (
            <div className="schedule-more">
              +{sortedDays.length - 3} more days
            </div>
          )}
        </div>

        {vendor.facility_type && (
          <div style={{ marginTop: '8px' }}>
            <span className="listing-card-tag">{vendor.facility_type}</span>
          </div>
        )}
      </div>
    </div>
  )
}
